import styled from 'styled-components';

export const FilterListStyled = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  gap: 2vw;
  justify-content: space-between;
  padding: 0;
  margin: 0 0 2.4rem;
`;
